import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DrugsApi, type DrugFormData } from '@/api/domains/drugs.api';
import { DrugsQueryKeys } from '@/api/domains/drugs.query-keys';

type UpdateDrug = {
  id: number;
  drugData: DrugFormData;
};

export const useUpdateDrug = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, drugData }: UpdateDrug) => DrugsApi.updateDrug(id, drugData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: DrugsQueryKeys.refreshCurrentSearch() });
    },
  });
};
